export const selectPlanData = (currentPlan?: {
  variation: string;
  billingCycle: string;
}) => ({
  MONTHLY: {
    products: [
      {
        title: 'Basic',
        sku: 'cb57568e-56ab-4876-8f9c-fdb8a2916355',
        name: 'AirCycle Basic Monthly',
        orderPrice: 0.0,
        recurringPricePerDevice: 10.0,
        features: [
          `AirCycle custom reports, owner`,
          `dashboards, 1:1 linking of`,
          `devices to techs and on-going`,
          `access to training`,
        ],
        type: 'subscription',
        isActive:
          currentPlan &&
          currentPlan?.variation === 'BASIC' &&
          currentPlan?.billingCycle === 'MONTHLY',
      },
      {
        title: 'Advanced',
        sku: '6b03408e-9f53-492d-bd8a-54703f21442d',
        name: 'AirCycle Advanced Monthly',
        orderPrice: 0.0,
        recurringPricePerDevice: 15.0,
        features: [
          `Gain access to the sales`,
          `opportunity dashboard along`,
          `with the Basic plan's custom`,
          `reports, device linking and on-`,
          `going training`,
        ],
        type: 'subscription',
        isActive:
          currentPlan &&
          currentPlan?.variation === 'ADVANCED' &&
          currentPlan?.billingCycle === 'MONTHLY',
      },
    ],
  },
  YEARLY: {
    products: [
      {
        title: 'Basic',
        sku: 'ae181ac0-0df1-4124-9e9b-24dfe1bb3eb6',
        name: 'AirCycle Basic Annual',
        orderPrice: 0.0,
        recurringPricePerDevice: 120.0,
        features: [
          `AirCycle custom reports, owner`,
          `dashboards, 1:1 linking of`,
          `devices to techs and on-going`,
          `access to training`,
        ],
        type: 'subscription',
        isActive:
          currentPlan &&
          currentPlan?.variation === 'BASIC' &&
          currentPlan?.billingCycle === 'ANNUAL',
      },
      {
        title: 'Advanced',
        sku: 'aab2d927-d0b8-4063-a406-a70fb310ba6e',
        name: 'AirCycle Advanced Annual',
        orderPrice: 0.0,
        recurringPricePerDevice: 180.0,
        features: [
          `Gain access to the sales`,
          `opportunity dashboard along`,
          `with the Basic plan's custom`,
          `reports, device linking and on-`,
          `going training`,
        ],
        type: 'subscription',
        isActive:
          currentPlan &&
          currentPlan?.variation === 'ADVANCED' &&
          currentPlan?.billingCycle === 'ANNUAL',
      },
    ],
  },
});

export const productSubscriptionArray = [
  // item 0 MUST be for Basic Monthly service, see ProductDescription.tsx
  {
    name: 'AirCycle Basic Service Monthly',
    sku: 'cb57568e-56ab-4876-8f9c-fdb8a2916355',
    orderPrice: '0',
    recurringPricePerDevice: 10.0,
    quantity: 1,
    type: 'subscription',
  },
  // item 1 MUST be for Basic Annual service, see ProductDescription.tsx
  {
    name: 'AirCycle Basic Service Yearly',
    sku: 'ae181ac0-0df1-4124-9e9b-24dfe1bb3eb6',
    orderPrice: '0',
    recurringPricePerDevice: 120.0,
    quantity: 1,
    type: 'subscription',
  },
  // item 2 MUST be for Advanced Monthly service, see ProductDescription.tsx
  {
    name: 'AirCycle Advanced Service Monthly',
    sku: '6b03408e-9f53-492d-bd8a-54703f21442d',
    orderPrice: '0',
    recurringPricePerDevice: 15.0,
    quantity: 1,
    type: 'subscription',
  },
  // item 3 MUST be for Advanced Annual service, see ProductDescription.tsx
  {
    name: 'AirCycle Advanced Service Yearly',
    sku: 'aab2d927-d0b8-4063-a406-a70fb310ba6e',
    orderPrice: '0',
    recurringPricePerDevice: 180.0,
    quantity: 1,
    type: 'subscription',
  },
  // item 4 MUST be for AirCycle Monitor, see ProductDescription.tsx
  {
    name: 'AirCycle Pro Monitor',
    sku: 'IAQMNXXSA1000-U',
    orderPrice: '1495',
    quantity: 1,
    type: 'product',
  },
  // item 5 MUST be for Monitor Support Refresh, see ProductDescription.tsx
  {
    name: 'AirCycle Support Refresh',
    sku: 'HH05',
    orderPrice: '795',
    quantity: 1,
    type: 'refresh',
  },
  // item 6, currently, items below this line will be ignored, see ProductDescription.tsx
  {
    name: 'AirCycle Pro Monitor',
    sku: 'IAQMNXXSA1000',
    orderPrice: '1495',
    quantity: 1,
    type: 'product',
  },
  // item 7
  {
    name: 'Pro-IQ Essentials',
    sku: 'HH06',
    orderPrice: '0.00',
    recurringPrice: '0.99',
    quantity: 1,
    type: 'HAB',
  },
  {
    name: 'AirCycle Basic Monthly Device',
    sku: 'HH01',
    orderPrice: '10',
    type: 'AirCycle_device_subscription',
  },
  {
    name: 'AirCycle Basic Annual Device',
    sku: 'HH02',
    orderPrice: '15',
    type: 'AirCycle_device_subscription',
  },
  {
    name: 'AirCycle Advanced Monthly Device',
    sku: 'HH03',
    orderPrice: '120',
    type: 'AirCycle_device_subscription',
  },
  {
    name: 'AirCycle Advanced Annual Device',
    sku: 'HH04',
    orderPrice: '180',
    type: 'AirCycle_device_subscription',
  },
];

export const subscriptionOrderProducts = productSubscriptionArray.map(item => {
  return {
    name: item.name,
    sku: item.sku,
    type: item.type,
    orderPrice: item.orderPrice,
    recurringPrice: item.recurringPrice,
    recurringPricePerDevice: item.recurringPricePerDevice,
  };
});
